import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=4003ece0&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
import style0 from "./Task.vue?vue&type=style&index=0&id=4003ece0&prod&scoped=true&lang=css"
import style1 from "./Task.vue?vue&type=style&index=1&id=4003ece0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4003ece0",
  null
  
)

export default component.exports